import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Safely formats a number to a localized string.
 * Handles null, undefined, and NaN by returning a default value.
 */
export function formatSafeNumber(val: number | null | undefined, fallback = '0'): string {
  if (val === null || val === undefined || isNaN(val)) return fallback;
  
  // Custom formatting: ' for thousands, . for decimals
  const parts = val.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  return parts.join(".");
}

/**
 * Safely formats a currency value.
 */
export function formatSafeCurrency(val: number | null | undefined, currency = 'DA'): string {
  return `${formatSafeNumber(val)} ${currency}`;
}
